// People API routes
const PEOPLE = '/people'

export { PEOPLE }
